import { atom } from "recoil";

export const SearchKeyState = atom({
  key: "SearchKeyState",
  default: "",
});
